import { Injectable } from '@angular/core';
// import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { ModalController } from '@ionic/angular';
import { MmBarcodeScannerComponent } from 'src/app/components/mm-barcode-scanner/mm-barcode-scanner.component';

@Injectable({
    providedIn: 'root'
})
export class BarcodeScannerService {

    constructor(private modalController: ModalController) { }

    /**
     * Checks permission
     * @author Starley Cazorla
     * @returns
     */
    async checkPermission() {
        const status: any = null;  //await BarcodeScanner.checkPermission({ force: true });

        if (status.granted) {
            // the user granted permission
            return true;
        }

        return false;
    }

    /**
     * Starts scanner
     * @author Starley Cazorla
     * @returns
     */
    startScanner() {
        return new Promise(async (resolve) => {
            const modal = await this.modalController.create({
                component: MmBarcodeScannerComponent,
                cssClass: 'transparent-modal',
                backdropDismiss: false,
            });

            await modal.present();

            await modal.onDidDismiss().then(async (_data: any) => {

                if (_data !== undefined) {
                    console.log("🚀 ~ file: qr-code.service.ts:39 ~ QrCodeService ~ awaitmodal.onDidDismiss ~ _data:", _data)
                }
                resolve(_data)
            });
        });
    }

}
